import React from 'react';
import { Link } from 'react-router-dom';
import { FaFileInvoiceDollar, FaCalendarAlt, FaPlug, FaArrowRight } from 'react-icons/fa';
import './NFSeSpotlight.css';

const NFSE_TRIAL_URL =
  'https://nfe.updatecommit.com/?utm_source=updatecommit-site&utm_medium=home&utm_campaign=nfse';

const highlights = [
  { icon: <FaFileInvoiceDollar />, text: 'DANFSe oficial em PDF + XML' },
  { icon: <FaCalendarAlt />, text: 'Agendamento recorrente' },
  { icon: <FaPlug />, text: 'API e Webhooks para o seu ERP' },
];

const NFSeSpotlight: React.FC = () => {
  return (
    <section className="nfse-spotlight">
      <div className="nfse-spotlight-card">
        <div className="nfse-spotlight-content">
          <span className="nfse-spotlight-badge"><span aria-hidden="true">🧾</span> Novo produto</span>
          <h2 className="nfse-spotlight-title">
            UpdateCommit <span className="nfse-spotlight-highlight">NFS-e</span>
          </h2>
          <p className="nfse-spotlight-description">
            Emita, agende e envie suas Notas Fiscais de Serviço no padrão nacional — em segundos,
            sem portal da prefeitura. Teste 14 dias grátis, sem cartão.
          </p>
          <ul className="nfse-spotlight-list">
            {highlights.map((item) => (
              <li key={item.text}>
                <span className="nfse-spotlight-list-icon" aria-hidden="true">{item.icon}</span>
                {item.text}
              </li>
            ))}
          </ul>
          <div className="nfse-spotlight-buttons">
            <Link to="/solucoes/nfse" className="nfse-spotlight-cta">
              Conhecer o emissor <FaArrowRight aria-hidden="true" />
            </Link>
            <a
              href={NFSE_TRIAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="nfse-spotlight-cta-ghost"
            >
              Testar grátis
            </a>
          </div>
        </div>
        <div className="nfse-spotlight-visual" aria-hidden="true">
          <div className="nfse-spotlight-mock">
            <div className="nfse-spotlight-mock-header">
              <span className="nfse-spotlight-mock-dot"></span>
              <span className="nfse-spotlight-mock-dot"></span>
              <span className="nfse-spotlight-mock-dot"></span>
            </div>
            <div className="nfse-spotlight-mock-body">
              <div className="nfse-spotlight-mock-row">
                <span>NFS-2026-00123</span>
                <span className="nfse-spotlight-mock-status">EMITIDA</span>
              </div>
              <div className="nfse-spotlight-mock-row">
                <span>NFS-2026-00122</span>
                <span className="nfse-spotlight-mock-status">EMITIDA</span>
              </div>
              <div className="nfse-spotlight-mock-row">
                <span>NFS-2026-00121</span>
                <span className="nfse-spotlight-mock-status">EMITIDA</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NFSeSpotlight;
